import React from "react";
import { useState, useEffect } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import toast from "react-hot-toast";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { deleteRequest, getRequests } from "../services/userService";

const CurrentRequests = () => {
  const [requests, setRequests] = useState([]);

  const auth = useAuth();
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    getRequests(axiosPrivate, auth?.auth?.token)
      .then((response) => {
        setRequests(response.data);
        console.log("Requests fetched successfully");
      })
      .catch((error) => {
        console.error("Error fetching requests:", error);
      });
  }, [auth, axiosPrivate]);

  const deleteReq = (reqId) => {
    deleteRequest(axiosPrivate, reqId, auth?.auth?.token)
      .then((response) => {
        console.log(response);
        toast.success("Request Deleted!");
        const newList = requests.filter((item) => item.request_id !== reqId);
        setRequests(newList);
      })
      .catch((error) => {
        toast.error("Error in deletion!");
        console.log(error);
      });
  };

  return (
    <div className="font-cust1">
      <div className="flex flex-row space-x-16 p-5 bg-red-200 mt-2 font-semibold">
        <p className="w-20">Request Id</p>
        <p className="w-20">Bld Group Reqd.</p>
        <p className="w-20">Amt Reqd.</p>
        <p className="w-20">Interested Donors</p>
        <p className="w-20">Type</p>
      </div>
      {requests?.map((request, index) => (
        <div
          className="flex flex-row space-x-16 p-5 bg-red-100 mt-2"
          key={index}
        >
          <p className="w-20">{request?.request_id}</p>
          <p className="w-20">{request?.bldGrpRequired}</p>
          <p className="w-20">{request?.amount_Required}</p>
          <p className="w-20">{request?.noOfInterestedDonors}</p>
          <p className="w-20">{request?.emergencyLevel}</p>
          <Link to={`/admin/editreq/${request?.request_id}`}>
            <EditIcon />
          </Link>
          <button
            className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2"
            onClick={() => deleteReq(request.request_id)}
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  );
};

export default CurrentRequests;
